/**
 * La funzione genera un id univoco per un link di tipo `a`
 *
 *  */
export const getAnchorId = (text?: string): string => {
  if (!text) return '';
  return text.replace(/ /g, '_');
};
